export const studyDashboardQueryKeys = {
  root: ["studyDashboard"],
  progress: (authorization) => [...studyDashboardQueryKeys.root, "progress", authorization],
  streak: (authorization) => [...studyDashboardQueryKeys.root, "streak", authorization],
  leaderboard: (authorization) => [...studyDashboardQueryKeys.root, "leaderboard", authorization],
  resumeVideo: (authorization) => [...studyDashboardQueryKeys.root, "resumeVideo", authorization],
  resumeTests: (authorization, courseId, batchId, classId, targetId) => [
    ...studyDashboardQueryKeys.root,
    "resumeTests",
    authorization,
    courseId,
    batchId,
    classId,
    targetId,
  ],
  exploreStore: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "exploreStore",
    "withStoreCatalogAndHandbooks",
    authorization,
  ],
  handbookList: (authorization, productId = "") => [
    ...studyDashboardQueryKeys.root,
    "handbookList",
    authorization,
    productId,
  ],
  storeBanner: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "storeBanner",
    authorization,
  ],
  homeSliderBanners: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "homeSliderBanners",
    authorization,
  ],
  dailyGoal: (authorization) => [...studyDashboardQueryKeys.root, "dailyGoal", authorization],
  topWeakTopics: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "topWeakTopics",
    authorization,
  ],
  testWiseAnalysis: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "testWiseAnalysis",
    authorization,
  ],
  subjectPerformance: (authorization) => [
    ...studyDashboardQueryKeys.root,
    "subjectPerformance",
    authorization,
  ],
  scheduleWeek: (authorization, courseId, batchId) => [
    ...studyDashboardQueryKeys.root,
    "scheduleWeek",
    authorization,
    courseId,
    batchId,
  ],
  scheduleContent: (authorization, courseId, batchId, dayName, rawDate) => [
    ...studyDashboardQueryKeys.root,
    "scheduleContent",
    authorization,
    courseId,
    batchId,
    dayName,
    rawDate,
  ],
};
